export const GRID_SIZE = 14;
export const FRAME_RATE = 5;
export enum DirectionEnum {
  Up,
  Down,
  Left,
  Right,
}
